export default __webpack_public_path__ + "slices/main/assets/public/fonts/tiempos/tiempos-headline-medium.bd11bd9ed59f7bf308cdbcaffb6f9736.woff2";